import { createMemo } from 'solid-js';
import { createMagicDoorContext } from '~/contexts/utils';
import { companyBusinessInfoRepository } from '~/repositories/companyBusinessInfo';
import { createLazyResource } from '~/utils/resource';
export const [CompanyBusinessInfoProvider, useCompanyBusinessInfo] = createMagicDoorContext('CompanyBusinessInfo', () => {
  const [companyBusinessInfo, companyBusinessInfoActions] = createLazyResource(() => companyBusinessInfoRepository.getBusinessInfoList());

  const isShowBusinessInfoBanner = createMemo(
    () => companyBusinessInfo() && !companyBusinessInfo()?.some((item) => item.status === 'approved')
  );

  return {
    companyBusinessInfo,
    companyBusinessInfoActions,
    isShowBusinessInfoBanner,
  };
});
